import React, { useState, useEffect } from 'react';

import FileBase from "react-file-base64"

import Select from 'react-select'

import { Plant } from './index'
import { useDispatch, useSelector } from 'react-redux';
import { createPlants, updatePlant, getPlants } from '../actions/plants';
import { getBenefits } from '../actions/benefits';
// import benefits from '../reducers/benefits';

type PropsFormPlant = {
    currentPlantId?: number;
    setCurrentPlantId?: any;
};

const FormPlant: React.FC<PropsFormPlant> = ({ currentPlantId, setCurrentPlantId}) => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getBenefits())
    }, [dispatch])

    //Ajouter le type benefits
    const [plantData, setPlantData] = useState({ title: '', description: '', image: '', benefits: []});

    const [selectedValue, setSelectedValue] = useState([]);
    
    //Selected Plant
    const plant = useSelector((state: any) => currentPlantId ? state.plants.find((p) => p._id === currentPlantId) : null)
    
    //All plants and benefits
    const plants = useSelector((state: any) => state.plants)
    const benefits = useSelector((state: any) => state.benefits)

    const selectedBenefit = []
    useEffect(() => {
        if (plant) setPlantData(plant)
        if (plant) {
            plant.benefits.forEach(benefitId => {
                selectedBenefit.push(benefits.find((benefit) => benefit._id === benefitId))
            });
            setSelectedValue(selectedBenefit);
        }
    }, [plant])

    const options = benefits.map(benefit => ({
        label: benefit.title,
        value: benefit
    }));
    
    const handleChange = (e) => {
        setSelectedValue(Array.isArray(e) ? e.map(x => x.value) : []);
    }

    useEffect(() => {
        setPlantData({ ...plantData, benefits: selectedValue })
    }, [selectedValue])
    
    // useEffect(() => {
    //     console.log(selectedValue)
    // }, [selectedValue])
    

    
    

    const handleSubmitPlant = (e: any) => {
        e.preventDefault();
        if (currentPlantId) {
            console.log(plantData)
            dispatch(updatePlant(currentPlantId, plantData))
        } else {
            dispatch(createPlants(plantData));
            console.log("créer", plantData)
        }
        clearPlant();
    }
    
    const clearPlant = () => {
        setCurrentPlantId(null)
        setPlantData({ title: '', description: '', image: '', benefits: [] });
    }

    useEffect(() => {
        dispatch(getPlants())
    }, [currentPlantId, dispatch])
    

    return (
        <form className="_shadow-xl _bg-white _rounded-card _p-md _w-auto" onSubmit={handleSubmitPlant}>
            <h1 className="_text-center">{currentPlantId ? 'Modifier' : 'Créer'} une Plante </h1>
            <div className="_flex _flex-col">
                <input
                    className="_p-xs _rounded-md _my-sm _bg-gray"
                    type="text"
                    name="title"
                    value={plantData.title}
                    placeholder="Nom de la plante"
                    onChange={(e) => setPlantData({ ...plantData, title: e.target.value })}
                />
                <textarea
                    className="_p-xs _rounded-md _bg-gray _mb-sm"
                    style={{ height: '200px' }}
                    name="description"
                    value={plantData.description}
                    placeholder="description de la plante"
                    onChange={(e) => setPlantData({ ...plantData, description: e.target.value })}
                />
                {/* <Dropdown options={options} onChange={this._onSelect} value={defaultOption} placeholder="Select an option" />; */}
                <div className="_mb-md">
                    <h2 className="_mb-sm"> Choisissez un ou des benefices : </h2>
                     {/* <Select required classNamePrefix="select" className="basic-single" name="tags" options={options} getOptionValue={(option) => option.value} onChange={(item: any) => console.log(item.value)} /> */}
                            
                    {/* <Select value={options.filter(option => option.value === selectedValue[0])} classNamePrefix="select" className="basic-multi-select" name="benefits" isMulti options={options} onChange={(e) => { handleChange(e); setPlantData({ ...plantData, benefits: selectedValue }) }} /> */}
                    <Select classNamePrefix="select" className="basic-multi-select" name="benefits" isMulti options={options} getOptionValue={(option) => option.value} onChange={handleChange} />
                </div>
                <div className="_mb-sm">
                    <h2 className="_mb-sm"> Choisissez une image : </h2>
                    <FileBase
                        type="file"
                        name="images"
                        multiple={false}
                        className="_p-xs _rounded-md _mb-sm _bg-gray"
                        onDone={({base64}) => setPlantData({ ...plantData, image: base64})}
                    />
                </div>
            </div>
            <section className="_flex _flex-col">
                <h1 className="_my-sm"> Liste des plantes </h1>
                <div className="_flex _flex-wrap">
                    {plants.map((plant, i) => {
                    // return <SwiperSlide onClick={ (e) => setIsDetails(!isDetails) } key={i}><Post isForm={isForm} setCurrentPlantId={setCurrentPlantId} isDetails={isDetails} key={post._id} post={post} /></SwiperSlide>
                        return <Plant isForm={true} setCurrentPlantId={setCurrentPlantId} key={plant._id} plant={plant} />
                    })}
                </div>
            </section>
            <div className="_flex _justify-end _mt-sm">
                <button type="reset" onClick={clearPlant}>Annuler </button>
                <button type="submit" className="_ml-sm _bg-green _rounded-md hover:_bg-darkengreen _text-white _font-bold _py-xs _px-sm _rounded-lg">
                    {currentPlantId ? 'Modifier' : 'Créer'}
                </button>
            </div>
        </form>
    );
    
};

export default FormPlant;



